import DefaultLayout from "../components/layout/DefaultLayout";
import NewConsignForm from "../components/properties/NewConsignForm";
function ConsignPage() {
  const body = () => {
    return (
      <div>
        <section className="slice pt-4">
          <div className="container">
            <div className="text-center">
              <h2 className="heading heading-2 strong-400">
                Consigna tu propiedad
              </h2>
              <p>
                Nos puedes llamar o enviarnos los datos de tu propiedad a
                nuestro WhatsApp.
              </p>
              <a
                href="https://api.whatsapp.com/send?phone=573182962222&amp;text=Quiero%20consignar%20mi%20propiedad"
                className="btn-wa btn-styled btn-xl btn-base-2 btn-icon-left mt-4"
                target="_blank"
                rel="noreferrer noopener"
              >
                <i className="fa fa-whatsapp"></i> 318 296 2222
              </a>
              <span className="clearfix"></span>
              <p></p>
              <small>O si lo prefieres de llenar nuestro formulario </small>
            </div>
          </div>
        </section>
        <section className="slice pt-0 sct-color-1">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                {/* <!-- Contact form --> */}
                <NewConsignForm></NewConsignForm>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default ConsignPage;
